import StateBudgetAPI from '@/api/StateBudgetAPI.js';
import httpClient from '@/api/axios-httpclient';

export default {
	getProcessStateBudget: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: StateBudgetAPI.getAPIUrl() + '/processstatebudget'
		});

		if (res.Success) {
			return res;
		}
	},

	/**
	 * Lấy danh sách thiết lập khoản mục nộp nsnn
	 */
	loadStateBudgets: async function(context, payload) {
		//Gán loading
		context.commit('updateStateBudgetsLoaded', false);

		//Gọi dịch vụ
		let res = await httpClient.postAsync(
			{
				url: StateBudgetAPI.getAPIUrl() + '/paging',
				data: payload
			},
			true
		);

		//Xử lý thành công
		if (res.Success) {
			context.commit('updateStateBudgets', res);
		}

		//Gán loading
		context.commit('updateStateBudgetsLoaded', true);

		// Trả kết quả
		return res.Data;
	},

	/**
	 * Lấy thông tin chi tiết của 1 thiết lập nộp nsnn
	 */
	getStateBudget: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: StateBudgetAPI.getAPIUrl() + '/get',
				params: payload
			},
			true
		);

		return res;
	},

	/**
	 * Lưu thông tin thiết lập khoản nộp nsnn
	 */
	saveStateBudget: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: StateBudgetAPI.getAPIUrl() + '/save',
				data: payload
			},
			true
		);

		return res;
	},

	/**
	 * Thay đổi trạng thái của thiết lập khoản nộp nsnn
	 */
	changeInactive: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: StateBudgetAPI.getAPIUrl() + '/active',
				data: payload
			},
			true
		);

		return res;
	},

	/**
	 * Lấy lại thông tin mặc định của 1 thiết lập nộp nsnn
	 */
	getDefault: async function(context, payload) {
		let res = await httpClient.getAsync(
			{
				url: StateBudgetAPI.getAPIUrl() + '/getdefault',
				params: payload
			},
			true
		);

		return res;
	},

	/**
	 * Validate tiểu mục
	 */
	validateStateBudget: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: StateBudgetAPI.getAPIUrl() + '/validate',
				data: payload
			},
			true
		);

		return res;
	}
};
